import { USER_TIMEZONE_VALUE } from '../../../../utils';

import { selectPropertyTimezones } from './selectPropertyTimezones';
import type { IHandleScopeQueriesResultChangedArgs } from './typings';

export function handleScopeQueriesResultChanged(args: IHandleScopeQueriesResultChangedArgs) {
  const { permissionScope, scopeQueriesResult, setFieldValue } = args;

  // Make this information available to other components
  setFieldValue('scopeQueriesResult', scopeQueriesResult);

  const {
    propertyTimezones,
    propertyTimezoneWarning,
  } = selectPropertyTimezones({ permissionScope, scopeQueriesResult });

  if (propertyTimezones.length === 1) {
    setFieldValue('selectedTimezone', propertyTimezones[0]); // Auto-select property timezone
    setFieldValue('propertyTimezone', propertyTimezones[0]);
  } else {
    // Default to user timezone if there are multiple (or zero) property timezones
    setFieldValue('selectedTimezone', USER_TIMEZONE_VALUE);
    setFieldValue('propertyTimezone', null);
  }

  setFieldValue('propertyTimezoneWarning', propertyTimezoneWarning);
}
